import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import { Box } from "@mui/material";

function BushelPrice({ bushelPrice, handleChange, handleBlur }) {
  return (
    <Box m={0} width="100%" align="center">
      <h2 className="sectionTitle center">Price Per Bushel</h2>
      <Box m={1}>
        <TextField
          autoFocus
          variant="standard"
          name="price_per_bushel"
          label="Bushel Price"
          type="number"
          inputProps={{ min: 0, step: "0.01", style: { textAlign: "center" } }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          value={bushelPrice}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </Box>
    </Box>
  );
}

export default BushelPrice;
